__webpack_require__.p = "https://inspirededu.azureedge.net/global-study-platform/";